/**
 * This class strips the Measurement of things that are not actually used or relevant
 * to Stage, specifically anchoring and stretching. Measurements can also contain
 * volume and area, but these are ignored. Here Measures are used to define defaults
 * such as its preferences when dealing with ambiguity or its default value.
 */
export class CfgMeasureDefinition {
    constructor(measureParamCode, numericValue, measurePriorities) {
        this.measureParamCode = measureParamCode;
        this.numericValue = numericValue;
        this.measurePriorities = measurePriorities;
    }
    static make(measurement) {
        // The measurement.code seems to be used in CET to connect the value to
        // pre-existing fields in the product, such as width, height and depth.
        // We however only use this for anchoring and stretching and so it is the
        // code of the measureParam that is relevant. Hence Measurements with no
        // measureParam are ignored.
        var _a;
        const measureParam = measurement.measureParam;
        if (measureParam === undefined) {
            return undefined;
        }
        const code = measureParam.code;
        return new this(code, measurement.numericValue, ((_a = measureParam.measurePriority) !== null && _a !== void 0 ? _a : []).map((p, index) => ({
            modelLocalFilePath: p.url,
            index,
        })));
    }
}
